import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'
import React from 'react'
import { EmptyNumber } from '../EmptyNumber'

export const FinanceInfoItem: React.FC<{
  label: string
  labelAnnotation?: string
  value: React.ReactNode | null
  valueAnnotationDesc?: string
  valueAnnotationDate?: string | null
  className?: string
}> = (props) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-basis: 50%;
      `}
      className={props.className}
    >
      <div
        css={css`
          flex: 1;
        `}
      >
        <div
          css={css`
            color: ${colors.textStrong};
            font-weight: ${font.weight.bold};
            font-size: 13px;
            margin-top: 5px;
          `}
        >
          {props.label}
        </div>
        <div
          css={css`
            color: ${colors.textLight};
            font-size: 13px;
            margin-top: 5px;
          `}
        >
          {props.labelAnnotation}
        </div>
      </div>
      <div
        css={css`
          flex: 2;
          padding-left: 40px;
        `}
      >
        <div
          css={css`
            line-height: 1.2;
          `}
        >
          {props.value || <EmptyNumber />}
        </div>
        {props.valueAnnotationDate ? (
          <div
            className="date"
            css={css`
              font-size: 12px;
              color: ${colors.textLight};
              margin-top: 4px;
            `}
          >
            {props.valueAnnotationDesc}：
            <span
              css={css`
                font-size: 12px;
                color: ${colors.textLight};
              `}
            >
              {props.valueAnnotationDate}
            </span>
          </div>
        ) : (
          <div
            css={css`
              width: 166px;
            `}
          />
        )}
      </div>
    </div>
  )
}
